import React from "react";
import Filter, { FilterProps } from "elements/Filter/Filter";
import { hasValue } from "utilities/filters/filters";
import {
  defaultFilterState,
  InsightFilterState
} from "routes/Insights/Priority/QueryParams";
import { keyIter } from "utilities/objectUtils";

export const InsightFilter = (props: FilterProps<InsightFilterState>) => (
  <Filter {...props} />
);

export const areInsightFiltersSelected = (
  filterValues: InsightFilterState
): boolean => {
  let filtersSelected = false;
  keyIter(defaultFilterState).forEach(key => {
    if (key !== "sort" && hasValue(filterValues, key)) {
      filtersSelected = true;
    }
  });

  return filtersSelected;
};
